<template>
  <div class="CreatingVideoConference">
    <div class="title">
      <div class="text">创建视频会议</div>
      <div class="close" @click="close"></div>
    </div>
    <main class="PersonneList">
      <div class="List">
        <!-- 相关单位 -->
        <div class="CoherentUnits">
          <div class="sub_title">相关单位</div>
          <div class="left_wrap">
            <div
              class="content"
              @click.stop="itemshow(i)"
              v-for="(it, i) in list"
              :key="i"
            >
              <div class="content_unit">
                <div class="content_icon"></div>
                <div class="content_title">{{ it.title }}</div>
                <div
                  class="content_btn"
                  :class="currindex == i ? 'open' : ''"
                ></div>
              </div>
              <div
                class="box"
                v-for="(item, index) in it.children"
                :key="index"
                v-show="currindex == i"
              >
                <div class="name">{{ item.name }}</div>
                <div :class="['job', { leader: item.job != '值班人员' }]">
                  {{ item.job }}
                </div>
                <div
                  :class="{ add: item.selected }"
                  @click.stop="addUserMetting(item, index)"
                >
                  {{ item.selected ? '已添加' : '添加' }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 参会人员 -->
        <div class="Conferee">
          <div class="sub_title">参会人员</div>
          <div class="right_wrap">
            <div class="content" v-for="(it, i) in list" :key="i">
              <template v-for="(item, index) in it.children">
                <div class="box" v-if="item.selected" :key="index + 10">
                  <div class="name">{{ item.name }}</div>
                  <div class="remove" @click="removeUserMetting(item, index)">
                    移除
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
      <div
        :class="actlist.length >= 2 ? 'Creating' : 'noBegin'"
        @click="beginMetting"
      >
        <span>创建</span>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currindex: null,
      list: [
        {
          title: '安全主管部门',
          English: 'Bureau of Transportation',
          children: [
            {
              name: '张吉惟',
              English: 'Brynn',
              selected: false,
              job: '主任',
              Ejob: 'Director',
              itemshow: true,
            },
            {
              name: '阮建安',
              English: 'Ellie',
              Ejob: 'Staff on Duty',
              selected: false,
              job: '值班人员',
              itemshow: true,
            },
          ],
        },
        {
          title: '技术部',
          English: 'Urban Management Bureau',
          children: [
            {
              name: '林雅南',
              English: 'Ainsley',
              Ejob: 'Staff on Duty',
              selected: false,
              job: '值班人员',
              itemshow: true,
            },
          ],
        },
        {
          title: '设备部',
          English: 'Commerce Bureau',
          children: [
            {
              name: '林玟书',
              English: 'Bella',
              Ejob: 'Staff on Duty',
              selected: false,
              job: '值班人员',
              itemshow: true,
            },
          ],
        },
        {
          title: '网络部',
          English: 'Traffic Police Brigade',
          children: [
            {
              name: '刘宏',
              English: 'Bellas',
              Ejob: 'Staff on Duty',
              selected: false,
              job: '值班人员',
              itemshow: true,
            },
          ],
        },
        {
          title: '软件系统部',
          English: 'Housing and Urban-rural Development Bureau',
          children: [
            {
              name: '江奕云',
              English: 'Ainsleys',
              Ejob: 'Staff on Duty',
              selected: false,
              job: '值班人员',
              itemshow: true,
            },
          ],
        },
        {
          title: '网管部',
          English: 'Development and Reform Commission',
          children: [
            {
              name: '林国瑞',
              English: 'Ellies',
              Ejob: 'Staff on Duty',
              selected: false,
              job: '值班人员',
              itemshow: true,
            },
          ],
        },
        {
          title: '信息管理部',
          English: 'public security bureau',
          children: [
            {
              name: '张倩',
              English: 'Tom',
              Ejob: 'Staff on Duty',
              selected: false,
              job: '值班人员',
              itemshow: true,
            },
          ],
        },
      ],
      actlist: [],
    }
  },

  methods: {
    itemshow(i) {
      if (this.currindex == i) {
        this.currindex = null
      } else {
        this.currindex = i
      }
    },
    close() {
      this.$emit('beginMetting')
    },
    addUserMetting(item) {
      if (!item.selected) {
        //已经选中
        item.selected = !item.selected
        this.actlist.push(item)
      }
    },
    removeUserMetting(item, index) {
      this.actlist.splice(index, 1)
      item.selected = !item.selected
    },
    beginMetting() {
      if (this.actlist.length < 2) return
      // 向右侧视频列表传值
      this.$eventBus.$emit('videoAmount', this.actlist)
      this.$eventBus.$emit('isShowSurroundingMonitoring', true)
      // 传值过后将数组置空
      this.actlist = []
      // 将标题选中状态置空
      this.currindex = null
      // 将选中项还原
      this.list.forEach((item) => {
        item.children.forEach((val) => {
          val.selected = false
        })
      })
      this.$emit('beginMetting')
    },
  },
}
</script>

<style lang="less" scoped>
.CreatingVideoConference {
  transform: scale(0.5);
  width: 780px;
  height: 481px;
  pointer-events: all;

  .title {
    width: 780px;
    height: 40px;
    background: url('../../assets/img/pageCard/ShiPinHuiYi/TITLE.png') no-repeat
      100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 13px 0px 51px;
    box-sizing: border-box;

    .text {
      font-family: '微软雅黑';
      font-size: 20px;
      background-image: linear-gradient(
        to bottom,
        rgb(255, 255, 255),
        rgb(153, 236, 251)
      );
      background-clip: text;
      -webkit-background-clip: text;
      color: transparent;
    }

    .close {
      width: 15px;
      height: 15px;
    }
  }

  .PersonneList {
    margin-top: 1px;
    width: 100%;
    height: 440px;
    background: rgba(23, 36, 53, 0.85);
    padding: 10px 20px 0;
    box-sizing: border-box;
    position: relative;

    .List {
      width: 100%;
      height: 360px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .CoherentUnits,
      .Conferee {
        .sub_title {
          height: 20px;
          line-height: 20px;
          padding-left: 10px;
          font-family: '微软雅黑';
          font-size: 18px;
          background-image: linear-gradient(
            to bottom,
            rgb(255, 255, 255),
            rgb(153, 236, 251)
          );
          background-clip: text;
          -webkit-background-clip: text;
          color: transparent;
          position: relative;
          margin-bottom: 10px;

          &::after {
            content: '';
            position: absolute;
            top: 0px;
            left: 0px;
            width: 3px;
            height: 20px;
            background: #1feaef;
          }
        }

        .left_wrap,
        .right_wrap {
          width: 351px;
          height: 330px;
          border: 1px solid rgba(255, 255, 255, 0.3);
          background: repeating-linear-gradient(
            to bottom,
            rgba(23, 36, 53, 0.4) 0px,
            rgba(23, 36, 53, 0.4) 30px,
            rgba(255, 255, 255, 0.05) 30px,
            rgba(255, 255, 255, 0.05) 60px
          );
          box-sizing: border-box;
        }
      }

      .content {
        width: 350px;
        border-radius: 2px;
        .content_unit {
          position: relative;
          display: flex;
          height: 30px;
          .content_icon {
            margin: 12px 5px 0;
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background-color: #1feaef;
          }
          .content_title {
            color: #ffffff;
            font-family: '微软雅黑';
            font-size: 14px;
            line-height: 30px;
          }

          .content_btn {
            position: absolute;
            top: 12px;
            right: 30px;
            width: 16px;
            height: 12px;
            background: url('../../assets/img/pageCard/ShiPinHuiYi/videoBtnBottom.png');
          }
          .open {
            background: url('../../assets/img/pageCard/ShiPinHuiYi/videoBtnTop.png')
              no-repeat;
          }
        }
      }

      .content .box {
        height: 30px;
        line-height: 30px;
        padding: 0 20px;
        display: flex;
        color: #ffffff;
        font-family: '微软雅黑';
        font-size: 14px;

        & > div {
          font-family: '微软雅黑';
          font-size: 14px;
        }
      }

      .box .name {
        width: 70px;
      }
      .box .job {
        width: 180px;
      }
      .box .leader {
        color: #06ffe7;
      }
      .box .add {
        color: #01bae9;
      }
      .right_wrap .box {
        justify-content: space-between;
      }

      .remove {
        color: #f87c7c;
      }
    }

    .Creating {
      border: 1px rgba(0, 63, 100, 0.3) solid;
      border-radius: 2px;
      width: 120px;
      height: 30px;
      text-align: center;
      line-height: 30px;
      position: absolute;
      z-index: 1;
      left: 50%;
      bottom: 20px;
      transform: translateX(-50%);
      background: linear-gradient(to bottom, #0be6c5, #09a891);

      & > span {
        font-weight: bold;
        font-family: '微软雅黑';
        font-size: 18px;
        background: linear-gradient(to bottom, #fff, #c5fcf3);
        -webkit-background-clip: text;
        color: transparent;
      }
    }

    .noBegin {
      border: 1px rgba(0, 63, 100, 0.3) solid;
      border-radius: 2px;
      width: 120px;
      height: 30px;
      text-align: center;
      line-height: 30px;
      position: absolute;
      z-index: 1;
      left: 50%;
      bottom: 20px;
      transform: translateX(-50%);
      background: #888;
      & > span {
        font-weight: bold;
        font-family: '微软雅黑';
        font-size: 18px;
        background: linear-gradient(to bottom, #fff, #c5fcf3);
        -webkit-background-clip: text;
        color: transparent;
      }
    }
  }
}
</style>
